import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { Angular2SignaturePadModule } from "../../components/angular2-signaturepad/angular2-signaturepad.module";
import { GyzmoButtonModule } from "../../components/gyzmo-button/gyzmo-button.module";
import { CropModalModule } from "../crop/crop.module";
import { DrawModal } from "./draw.modal";

@NgModule(
    {
        declarations: [
            DrawModal,
        ],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            TranslateModule,
            GyzmoButtonModule,
            Angular2SignaturePadModule,
            CropModalModule,
        ],
        providers: [],
    })

export class DrawModalModule {
}
